import React, { useState } from 'react';
import axios from '../../api/axios';
import './LetterViewModal.css';

const API = 'https://expertise.gov.kz/api';

const cellStyle = {
  border: '1px solid #ddd',
  padding: '0.5rem',
  backgroundColor: '#f9f9f9',
};

export default function LetterViewModal({ letters, onClose, locale, onSign, profile }) {
  const [showSignatures, setShowSignatures] = useState({});
  const [signingId, setSigningId] = useState(null);
  const [signingStep, setSigningStep] = useState('');
const [signingStepRu, setSigningStepRu] = useState('');

  const token = localStorage.getItem('token');
  const authHeaders = { Authorization: `Bearer ${token}` };

  // ✅ PDF жүктеу
  const handleDownloadPdf = async (id) => {
    try {
      const response = await axios.get(`${API}/letters/${id}/download-pdf`, {
        responseType: 'blob',
        headers: authHeaders,
      });

      const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `letter_${id}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('PDF жүктеу қатесі:', error);
      alert(locale === 'kz' ? '❌ PDF жүктеу қатесі' : '❌ Ошибка при скачивании PDF');
    }
  };

  // ✅ Қол қою
  const handleSign = async (letter) => {
    if (!window.NCA) {
      alert(locale === 'kz'
        ? '❌ NCALayer табылмады. Бағдарламаны іске қосып қайталаңыз.'
        : '❌ NCALayer не найден. Запустите программу и повторите.');
      return;
    }

    setSigningId(letter.id);

    try {
      // 1) NCALayer-ге қосылу
      setSigningStep(locale === 'kz' ? 'NCALayer қосылуда...' : 'Подключение NCALayer...');
      const connected = await window.NCA.connect();
      if (!connected) {
        alert(locale === 'kz'
          ? '❌ NCALayer іске қосылмаған'
          : '❌ NCALayer не запущен');
        setSigningId(null);
        return;
      }

      // 2) PDF base64 алу
      setSigningStep(locale === 'kz' ? 'PDF алынуда...' : 'Получение PDF...');
      const res = await axios.get(`${API}/letters/${letter.id}/base64`, {
        headers: authHeaders,
      });

      const base64 = res.data?.base64;
      if (!base64) {
        alert(locale === 'kz' ? '❌ PDF табылмады' : '❌ PDF не найден');
        setSigningId(null);
        return;
      }

      // 3) NCALayer арқылы CMS қол қою
     setSigningStep(locale === 'kz' ? 'Қол қойылуда...' : 'Подписание...');
      window.NCA.createCMSSignatureFromBase64(
        'PKCS12',
        'SIGNATURE',
        base64,
        true,
        async (result) => {
          const code = result?.getCode ? result.getCode() : result?.code;

          if (String(code) !== '200') {
            if (String(code) !== '100') {
              alert(locale === 'kz' ? '❌ Қол қою сәтсіз' : '❌ Подпись не выполнена');
            }
            setSigningId(null);
            return;
          }

          const signedCms = result?.getResponseObject
            ? result.getResponseObject()
            : result?.responseObject;

          // 4) Серверге жіберу
          try {
            await axios.post(
              `${API}/letters/${letter.id}/sign`,
              { signed_cms_base64: signedCms },
              { headers: { ...authHeaders, 'Content-Type': 'application/json' } }
            );

            alert(locale === 'kz' ? '✅ Хатқа сәтті қол қойылды!' : '✅ Письмо успешно подписано!');
            onClose();

            // Беттi жаңарту
            window.location.reload();
          } catch (err) {
            const msg = err?.response?.data?.message || err.message;
            alert(`❌ ${msg}`);
          } finally {
            setSigningId(null);
            setSigningStep('');
          }
        }
      );
    } catch (err) {
      console.error('Қол қою қатесі:', err);
      alert(locale === 'kz' ? '❌ Жүйелік қате' : '❌ Системная ошибка');
      setSigningId(null);
    }
  };

  // Пайдаланушы гос па?
  const isGos = profile?.username === 'gos' || profile?.department_id === 6;

  // Пайдаланушы director па?
  const isDirector = profile?.username === 'direktor' || profile?.role_name === 'director';

  const canGosSign = (letter) =>
    isGos && letter.status === 'күтілуде' && !letter.gov_signed_at;

  const canDirectorSign = (letter) =>
    isDirector &&
    (letter.status === 'күтілуде' || letter.status === 'гос қол қойды') &&
    letter.gov_signed_at &&
    !letter.director_signed_at;

    // CSS анимация спиннера — один раз
  if (!document.getElementById('lvm-spin-style')) {
    const style = document.createElement('style');
    style.id = 'lvm-spin-style';
    style.textContent = '@keyframes lvm-spin { to { transform: rotate(360deg); } }';
    document.head.appendChild(style);
  }

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
        backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex',
        justifyContent: 'center', alignItems: 'center', zIndex: 9999,
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: '#fff', padding: '2rem', borderRadius: '8px',
          width: '700px', maxHeight: '90vh', overflowY: 'auto',
          position: 'relative',
        }}
      >
        {/* Жабу */}
        <button
          onClick={onClose}
          style={{
            position: 'absolute', top: 10, right: 10,
            background: 'transparent', border: 'none',
            fontSize: '1.5rem', cursor: 'pointer',
          }}
        >
          ×
        </button>

        <h2 style={{ marginBottom: '1.5rem' }}>
          {locale === 'kz' ? '📬 Хаттар тізімі' : '📬 Список писем'}
        </h2>

        {letters.length === 0 ? (
          <p style={{ color: '#888' }}>
            {locale === 'kz' ? 'Хаттар табылмады' : 'Писем нет'}
          </p>
        ) : (
          <ul style={{ paddingLeft: 0, listStyle: 'none', margin: 0 }}>
            {letters.map((letter) => {
              const isShown = showSignatures[letter.id] || false;
              const isSigning = signingId === letter.id;

              // Қол қою тізімін жинау
              const signatures = [];
              if (letter.gov_signed_at) {
                signatures.push({
                  full_name: letter.gov_signed_by_user_name || 'Гос-сервис',
                  signed_at: letter.gov_signed_at,
                });
              }
              if (letter.director_signed_at) {
                signatures.push({
                  full_name: letter.director_signed_by_user_name || 'Директор',
                  signed_at: letter.director_signed_at,
                });
              }

              // Статус түсі
              const statusColor = {
                'күтілуде':       '#f0ad4e',
                'гос қол қойды':  '#5bc0de',
                'қол қойылды':    '#5cb85c',
              }[letter.status] || '#aaa';

              return (
                <li
                  key={letter.id}
                  style={{
                    border: '1px solid #e0e0e0',
                    borderRadius: '8px',
                    padding: '1rem',
                    marginBottom: '1rem',
                    backgroundColor: '#fafafa',
                  }}
                >
                  {/* Хат мәліметі */}
                  <div style={{ marginBottom: '0.5rem' }}>
                    <strong>№ {letter.outgoing_number}</strong>
                    <span
                      style={{
                        marginLeft: '1rem',
                        padding: '2px 8px',
                        borderRadius: '12px',
                        backgroundColor: statusColor,
                        color: '#fff',
                        fontSize: '0.8rem',
                      }}
                    >
                      {letter.status}
                    </span>
                  </div>

                  <p style={{ margin: '0.3rem 0', fontSize: '0.9rem', color: '#333' }}>
                    <strong>{locale === 'kz' ? 'Тақырып' : 'Тема'}:</strong> {letter.theme}
                  </p>

                  <p style={{ margin: '0.3rem 0', fontSize: '0.85rem', color: '#666' }}>
                    {new Date(letter.created_at).toLocaleString(locale === 'kz' ? 'kk-KZ' : 'ru-RU')}
                  </p>

                  {/* Кнопкалар */}
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem', marginTop: '0.8rem' }}>

                    {/* PDF жүктеу */}
                    {letter.pdf_path && (
                      <button
                        onClick={() => handleDownloadPdf(letter.id)}
                        style={{
                          padding: '0.4rem 0.8rem',
                          backgroundColor: '#6c757d', color: '#fff',
                          border: 'none', borderRadius: '4px', cursor: 'pointer',
                        }}
                      >
                        📥 {locale === 'kz' ? 'PDF жүктеу' : 'Скачать PDF'}
                      </button>
                    )}

                    {/* Гос қол қою */}
                    {canGosSign(letter) && (
                      <button
                        onClick={() => handleSign(letter)}
                        disabled={isSigning}
                        style={{
                          display: 'inline-flex', alignItems: 'center', gap: '8px',
                          padding: '0.4rem 0.8rem',
                          backgroundColor: isSigning ? '#aaa' : '#28a745',
                          color: '#fff', border: 'none', borderRadius: '4px',
                          cursor: isSigning ? 'not-allowed' : 'pointer',
                          minWidth: '180px',
                        }}
                      >
                        {isSigning ? (
                          <>
                            <span style={{
                              width: '13px', height: '13px', flexShrink: 0,
                              border: '2px solid rgba(255,255,255,0.35)',
                              borderTopColor: '#fff',
                              borderRadius: '50%',
                              animation: 'lvm-spin 0.7s linear infinite',
                              display: 'inline-block',
                            }} />
                            {signingStep}
                          </>
                        ) : (
                          locale === 'kz' ? '🔐 ЭЦҚ қол қою' : '🔐 Подписать ЭЦП'
                        )}
                      </button>
                    )}

                    {/* Director қол қою */}
                    {canDirectorSign(letter) && (
                      <button
                        onClick={() => handleSign(letter)}
                        disabled={isSigning}
                        style={{
                          display: 'inline-flex', alignItems: 'center', gap: '8px',
                          padding: '0.4rem 0.8rem',
                          backgroundColor: isSigning ? '#aaa' : '#007bff',
                          color: '#fff', border: 'none', borderRadius: '4px',
                          cursor: isSigning ? 'not-allowed' : 'pointer',
                          minWidth: '180px',
                        }}
                      >
                        {isSigning ? (
                          <>
                            <span style={{
                              width: '13px', height: '13px', flexShrink: 0,
                              border: '2px solid rgba(255,255,255,0.35)',
                              borderTopColor: '#fff',
                              borderRadius: '50%',
                              animation: 'lvm-spin 0.7s linear infinite',
                              display: 'inline-block',
                            }} />
                            {signingStep}
                          </>
                        ) : (
                          locale === 'kz' ? '🔐 ЭЦҚ арқылы қол қою' : '🔐 Подписать ЭЦП'
                        )}
                      </button>
                    )}
                  </div>

                  {/* Қол қою тізімі */}
                  {signatures.length > 0 && (
                    <div style={{ marginTop: '0.8rem' }}>
                      <button
                        onClick={() =>
                          setShowSignatures((prev) => ({
                            ...prev,
                            [letter.id]: !prev[letter.id],
                          }))
                        }
                        style={{
                          padding: '0.3rem 0.8rem',
                          border: '1px solid #007bff',
                          borderRadius: '6px',
                          backgroundColor: isShown ? '#007bff' : '#fff',
                          color: isShown ? '#fff' : '#007bff',
                          cursor: 'pointer',
                          fontWeight: 500,
                          fontSize: '0.85rem',
                          marginBottom: '0.5rem',
                        }}
                      >
                        {isShown ? '🔼 ' : '🔽 '}
                        {locale === 'kz'
                          ? 'Қол қою тізімі'
                          : 'Список подписей'}
                      </button>

                      {isShown && (
                        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                          <thead>
                            <tr>
                              <th style={cellStyle}>#</th>
                              <th style={cellStyle}>{locale === 'kz' ? 'Аты-жөні' : 'ФИО'}</th>
                              <th style={cellStyle}>{locale === 'kz' ? 'Қолы' : 'Подпись'}</th>
                              <th style={cellStyle}>{locale === 'kz' ? 'Мерзімі' : 'Дата'}</th>
                            </tr>
                          </thead>
                          <tbody>
                            {signatures.map((sig, idx) => (
                              <tr key={idx}>
                                <td style={cellStyle}>{idx + 1}</td>
                                <td style={cellStyle}>{sig.full_name}</td>
                                <td style={{ ...cellStyle, textAlign: 'center' }}>
                                  {sig.signed_at ? '✅' : '—'}
                                </td>
                                <td style={cellStyle}>
                                  {sig.signed_at
                                    ? new Date(sig.signed_at).toLocaleString(
                                        locale === 'kz' ? 'kk-KZ' : 'ru-RU'
                                      )
                                    : '—'}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      )}
                    </div>
                  )}
                </li>
              );
            })}
          </ul>
        )}
      </div>
    </div>
  );
}